var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "club-container" },
    [
      _c(
        "div",
        { staticClass: "image-container" },
        [
          _c("node-element-local-tasks", {
            attrs: {
              itemid: _vm.club.id,
              options: {
                mode: "view",
                ...(_vm.single ? {} : { destination: "/wineclubs" }),
              },
            },
          }),
          _vm._v(" "),
          _vm.club.image && _vm.club.image.filepath
            ? _c("AImage", {
                attrs: { img: _vm.club.image, preset: "wineclubteaser" },
              })
            : _c("div", { staticClass: "image-placeholder" }),
          _vm._v(" "),
          _c("div", { staticClass: "title-container" }, [
            _c("h1", [_vm._v(_vm._s(_vm.club.title))]),
            _vm._v(" "),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.club.abstract) } }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "club-description",
        domProps: { innerHTML: _vm._s(_vm.club.body) },
      }),
      _vm._v(" "),
      _vm.club.customclub
        ? [
            _c("h2", { staticClass: "products-headline" }, [
              _vm._v("\n      Available Products For This Custom Club\n    "),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "products" }, [
              _c(
                "div",
                { staticClass: "products-container" },
                _vm._l(_vm.products, function (product) {
                  return _c("Product", {
                    key: product.id,
                    attrs: {
                      product: product,
                      "custom-club": _vm.club.customclub,
                    },
                  })
                }),
                1
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "selections-headline" }, [
        _vm._v("Selections For This Club"),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "selections" }, [
        _c(
          "div",
          { staticClass: "selections-container" },
          _vm._l(_vm.club.selections, function (item, index) {
            return _c("Selections", {
              key: item.id,
              attrs: {
                selection: item,
                index: index + 1,
                "custom-club": _vm.club.customclub,
                "is-minified": _vm.isMinified,
              },
            })
          }),
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }